import { ThemeIcon, Tooltip } from "@mantine/core";
import { IconDeviceGamepad2 } from "@tabler/icons-react";
import { ControllerBatteryState, ControllerConnectionState } from "types/productTypes";
import {
  controllerBatteryTooltipStyles,
  hasLowControllerBattery,
} from "@utils/controllerBatteryUtils";
import ControllerBatteryTooltipContent from "./ControllerBatteryTooltipContent";

interface ControllerBatteryWarningIconProps {
  controllerState: ControllerConnectionState | null;
  controllerBattery: ControllerBatteryState | null;
  singleController?: boolean;
}

export default function ControllerBatteryWarningIcon({
  controllerState,
  controllerBattery,
  singleController = false,
}: ControllerBatteryWarningIconProps) {
  if (!hasLowControllerBattery(controllerBattery)) {
    return null;
  }

  return (
    <Tooltip
      withArrow
      multiline
      withinPortal
      zIndex={10000}
      styles={controllerBatteryTooltipStyles}
      label={
        <ControllerBatteryTooltipContent
          controllerState={controllerState}
          controllerBattery={controllerBattery}
          singleController={singleController}
        />
      }
    >
      <ThemeIcon color="red" variant="light" radius="xl" size="lg">
        <IconDeviceGamepad2 size={16} />
      </ThemeIcon>
    </Tooltip>
  );
}
